@if(getEffectiveShowSelection() && selected.length && (userRole() === roles.Administrator || userRole() === roles.CaseManager)){
<div class="flex mb-3 gap-3">
  @if(userRole() === roles.Administrator || userRole() === roles.CaseManager){
  <div class="flex gap-1">
    <p-select [options]="investigationOptions()" optionLabel="label" optionValue="value"
      [placeholder]="'CLAIMS.INVESTIGATION.SELECT_AN_INVESTIGATOR' | translate" appendTo="body"
      [(ngModel)]="selectedInvestigatorId" class="w-full" />
    <button #bulkAssignInvestigator pButton severity="success" [disabled]="!selectedInvestigatorId"
      (click)="onAssign(selected, null, selectedInvestigatorId)">
      {{ "CLAIMS.INVESTIGATION.ASSIGN" | translate }}
    </button>
  </div>
  } @if(userRole() === roles.Administrator){
  <div class="flex gap-1">
    <p-select [options]="caseManagerOptions()" optionLabel="label" optionValue="value"
      [placeholder]="'CLAIMS.INVESTIGATION.SELECT_A_MANAGER' | translate" appendTo="body"
      [(ngModel)]="selectedCaseManagerId" class="w-full" />
    <button #bulkAssignManager pButton severity="success" [disabled]="!selectedCaseManagerId"
      (click)="onAssign(selected, selectedCaseManagerId, null)">
      {{ "CLAIMS.INVESTIGATION.ASSIGN" | translate }}
    </button>
  </div>
  }
</div>
}
<div class="table-scroll-wrapper" #tableScrollWrapper>
  <div
    class="table-floating-header"
    #floatingHeader
    [class.is-visible]="showFloatingHeader"
  ></div>
  <p-table
    #caseTable
    [value]="rows"
    [dataKey]="getTableDataKey()"
    [(selection)]="selected"
    selectionMode="multiple"
    [lazy]="true"
    [paginator]="true"
    [rows]="pageSize()"
    [first]="(pageNumber() - 1) * pageSize()"
    [totalRecords]="totalRows()"
    [showJumpToPageDropdown]="false"
    [showJumpToPageInput]="false"
    [sortField]="getEffectiveSortField()"
    [sortOrder]="getEffectiveSortOrder()"
    [defaultSortOrder]="1"
    [loading]="isTableLoading"
    [scrollable]="true"
    styleClass="sticky-header-table"
    [rowHover]="true"
    (onLazyLoad)="onLazyLoad($event)"
    (selectionChange)="onPrimeSelectionChange($event)"
    (onRowExpand)="onPrimeRowExpand($event)"
    (onRowCollapse)="onPrimeRowCollapse($event)"
  >
    <ng-template pTemplate="colgroup">
      <colgroup>
        @if(getEffectiveShowSelection()){
          <col style="width: 22px" />
        }
        <col style="width: 22px" />
        @for(column of tableColumnsConfig(); track $index;){
          <col
            [style.width.px]="column.width || null"
            [style.minWidth.px]="column.width || null"
            [style.maxWidth.px]="column.width || null"
          />
        }
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        @if(getEffectiveShowSelection()){
          <th style="width: 22px"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        }
        <th style="width: 22px"></th>
        @for(column of tableColumnsConfig(); track $index;){
          <th
            [pSortableColumn]="(column.sortable ?? true) ? column.prop : ''"
            [style.width.px]="column.width || null"
            [style.minWidth.px]="column.width || null"
            [style.maxWidth.px]="column.width || null"
          >
            @if(column.sortable ?? true){
              <span class="header-cell-content is-sortable">
                <span class="header-label">{{ column.name | translate }}</span>
                <p-sortIcon class="header-sort-icon" [field]="column.prop"></p-sortIcon>
              </span>
            } @else {
              <span class="header-cell-content">
                <span class="header-label">{{ column.name | translate }}</span>
              </span>
            }
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr class="case-data-row" [class.is-new-case]="row.isNewCase === true">
        @if(getEffectiveShowSelection()){
          <td style="width: 22px">
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
        }
        <td style="width: 22px">
          <a href="javascript:void(0)" class="expand-collapse-icon ps-0" (click)="navigateToCaseDetails(row)">
            <i [class]="row.isViewedByCurrentUser ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
          </a>
        </td>
        @for(column of tableColumnsConfig(); track $index;){
          <td
            [class.date-stack-cell]="column.columnType === 'DATE' || column.columnType === 'DATE2'"
            [style.width.px]="column.width || null"
            [style.minWidth.px]="column.width || null"
            [style.maxWidth.px]="column.width || null"
          >
            <div class="cell-content-stack">
              @if(column.columnType ==="DATE"){
                <div class="cell-date-main">
                  {{ row[column.prop] ? (row[column.prop] | date : "dd/MM/yyyy") : "-" }}
                </div>
                @if(getEffectiveShowDateMetadata()){
                  <div style="margin-top: 0.5rem;">
                    <div class="cell-assignee-label text-black font-semibold text-base">
                      {{ getPrimaryAssigneeLabelKey(row) | translate }}
                    </div>
                    <span class="cell-assignee-value text-nowrap">{{ getPrimaryAssigneeValue(row) }}</span>
                  </div>
                }
              } @else if (column.columnType === "DATE2") {
                <div class="cell-date-main">
                  {{ row[column.prop] ? (row[column.prop] | date : 'dd/MM/yyyy') : "-" }}
                </div>
                @if(getEffectiveShowDateMetadata()){
                  <div class="cell-assignee-row" style="margin-top: 0.5rem;">
                    <div class="cell-assignee-label text-black font-semibold text-base">
                      {{ "CLAIMS.INVESTIGATION.INVESTIGATOR" | translate }}
                    </div>
                    <span class="cell-assignee-value text-nowrap">{{ row.investigator ?? ("CASE_DETAIL.Unassigned" | translate) }}</span>
                  </div>
                }
              } @else if (column.columnType === "DOB") {
                <div>
                  {{ row[column.prop] ? (row[column.prop] | date : "dd/MM/yyyy") : "-" }}
                </div>
              } @else if(column.columnType==='AMOUNT'){
                <span class="font-semibold text-gray-700 me-2">
                  {{ row[column.prop] > 0 ? (row[column.prop] | number) : "-" }}&euro;
                </span>
              } @else if(column.columnType==='INDEX'){
                <span [class]="getPriorityBadge(row[column.prop] || '')"></span>
              } @else if(column.columnType==='SEVERITY'){
                <span [class]="getSeverityBadge(row[column.prop] || '')">
                  {{ "CASE_DETAIL." + (row[column.prop] || "") | translate }}
                </span>
              } @else if(column.columnType==='STATUS'){
                <span>
                  {{ "CASE_DETAIL." + (row[column.prop] || "-") | translate }}
                </span>
              } @else if(column.columnType==='INSURANCE_RESPONSE'){
                <span>
                  {{ row[column.prop] || "-" }}
                </span>
              } @else if(column.columnType==='EMPIRICAL_RULE_INDEX'){
                <span [class]="getBooleanBadge(row[column.prop])">
                  <i [class]="getBooleanBadgeIcon(row[column.prop])"></i>
                </span>
              } @else if(column.columnType==='TRIAGING_INDEX'){
                <span [class]="getTriagingBadge(row[column.prop] || '')"></span>
              } @else {
                <span [class.two-line-cell-text]="column.prop === 'patientName' || column.prop === 'insuredName' || column.prop === 'hospitalName' || column.prop === 'hospital'">
                  {{ row[column.prop] }}
                </span>
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-row>
      <tr>
        <td [attr.colspan]="tableColumnsConfig().length + (getEffectiveShowSelection() ? 2 : 1)">
          <div class="flex flex-col p-5">
            <div class="detail-row-grid">
              <div class="flex justify-between w-full flex-wrap gap-y-9">
                @for(col of tableDetailConfig();track $index){
                  <div class="w-1/2">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center p-0 m-0 mr-3 border-0 bg-transparent text-primary cursor-pointer"
                      (click)="detailInfoPopover.toggle($event)"
                      aria-label="More info"
                    >
                      <i class="fa fa-circle-info text-lg"></i>
                    </button>
                    <p-popover #detailInfoPopover [dismissable]="false" [focusOnShow]="false">
                      <span>{{ getToolTip(col.name) }}</span>
                    </p-popover>
                    <strong class="detail-row-label">{{ col.name | translate }}&nbsp;:</strong>
                    <span class="detail-row-value">&nbsp;{{ row[col.prop] }}</span>
                  </div>
                }
              </div>
            </div>
            <div class="detail-row-grid">
              <div class="detail-row-column">
                @if( userRole() !== roles.Guest){
                  <button pButton class="max-w-3xs" severity="warn" (click)="navigateToCaseDetails(row)">
                    {{ "CLAIMS.INVESTIGATION.CLAIM_DETAILS" | translate }}
                  </button>
                }
              </div>
              <div class="detail-row-column">
                @if(userRole() === roles.Administrator){
                  <div class="flex items-center justify-end gap-2">
                    <p-select
                      [options]="caseManagerOptions()"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="'CLAIMS.INVESTIGATION.SELECT_A_MANAGER' | translate"
                      appendTo="body"
                      [(ngModel)]="selectedCaseManagerMap[row.caseId]"
                      class="w-full md:max-w-2xs"
                    />
                    <button pButton severity="success" [disabled]="!selectedCaseManagerMap[row.caseId]"
                      (click)="onAssign([row], selectedCaseManagerMap[row.caseId], null)">
                      {{ "CLAIMS.INVESTIGATION.ASSIGN" | translate }}
                    </button>
                  </div>
                }
                @if(userRole()=== roles.Administrator || userRole() === roles.CaseManager){
                  <div class="flex items-center justify-end gap-2">
                    <p-select
                      [options]="investigationOptions()"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="'CLAIMS.INVESTIGATION.SELECT_AN_INVESTIGATOR' | translate"
                      appendTo="body"
                      [(ngModel)]="selectedInvestigatorMap[row.caseId]"
                      class="w-full max-w-2xs"
                    />
                    <button pButton severity="success" [disabled]="!selectedInvestigatorMap[row.caseId]"
                      (click)="onAssign([row], null, selectedInvestigatorMap[row.caseId])">
                      {{ "CLAIMS.INVESTIGATION.ASSIGN" | translate }}
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div
    class="claims-total-overlay"
    style="
      position: absolute;
      left: 1rem;
      bottom: 0.7rem;
      z-index: 3;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.35rem 0.5rem 0.35rem 0.7rem;
      border: 1px solid #c8def1;
      border-radius: 9999px;
      background: linear-gradient(180deg, #ffffff 0%, #f6fbff 100%);
      box-shadow: 0 2px 8px rgba(18, 87, 115, 0.12);
      color: #125773;
      font-size: 0.86rem;
      line-height: 1;
      pointer-events: none;
    "
  >
    <span class="claims-total-label" style="font-weight: 600; letter-spacing: 0.01em;">
      {{ "CLAIMS.STATISTICS.TOTAL_CLAIMS" | translate }}
    </span>
    <span
      class="claims-total-value"
      style="
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 2.1rem;
        padding: 0.25rem 0.55rem;
        border-radius: 9999px;
        background: #125773;
        color: #ffffff;
        font-weight: 700;
      "
    >
      {{ totalRows() }}
    </span>
  </div>
</div>
<div
  class="table-bottom-scrollbar"
  #bottomScrollbar
  [class.is-visible]="showBottomScrollbar"
  [style.left.px]="bottomScrollbarLeft"
  [style.width.px]="bottomScrollbarWidth"
  (scroll)="onBottomScrollbarScroll()"
>
  <div class="table-bottom-scrollbar-content" [style.width.px]="bottomScrollbarContentWidth"></div>
</div>
<p-toast baseZIndex="100000" position="center" />
